import { http } from '@/plugins/axios'
import { Notify } from "vant";

// 接口环境
const env = 'production'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
  production: 'https://api.up-petroleum.com/api/v1/',
  development: 'https://apitest.up-petroleum.com/api/v1/',
}

// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env]
// const baseURL = apisURL[env]

/**
 * 获取文章详情
 * @param id 文章id
 * @returns {Promise<unknown>}
 */
function getArticle ({ id }) {
  return new Promise((resolve, reject) => {
    if (!id) {
      Notify({ type: 'warning', message: '文章Id为空' })
      return
    }

    http({ method: 'get', url: 'noticeInfo', data: { id }, myBaseUrl: baseURL }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

function formatDate(time) {
  if (time.lenght ===13 ) {
    time.substr(0, 10);
  }

  let dateObj = new Date(time * 1000)
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let date = dateObj.getDate();

  if (new Date().getFullYear() === year) {
    return '' + month + '月' + date + '日'
  } else {
    return ''+ year+ '年' + month + '月' + date + '日'
  }


}

export {
  getArticle,
  formatDate
}
